import { combineReducers } from '@reduxjs/toolkit'
import MarketReducer from './MarketsSlice'
import NewsReducer from '../news/store/NewsSlice'
import WatchListReducer from '../watchlist/store/WatchListSlice'
import MarketOverviewReducer from '../overview/store/MarketOverviewSlice'
import CompanyReducer from '../company/store/CompanySlice'
const MarketsReducer = combineReducers({
  market: MarketReducer,
  news: NewsReducer,
  watchlist: WatchListReducer,
  marketoverview: MarketOverviewReducer,
  company: CompanyReducer
})

export default MarketsReducer
